import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { lazyImport } from '@helpers'
import { withErrorBoundary, withI18next, withSuspense, withTheme } from '@hocs'
import { $settings } from '@velasca/utils/globals'

const { BannerNotRightStoreContainer } = lazyImport(
  () =>
    import(
      '@components/BannerNotRightStoreContainer/BannerNotRightStoreContainer'
    ),
  'BannerNotRightStoreContainer',
)

const bannerNotRightStoreEl = document.querySelector('#banner-not-right-store')

export const renderBannerNotRightStore = () => {
  // we don't want to show the banner in Playwright tests. This is more of a band-aid solution, as the real solution should be using proxies or mocking the calls, as described here: https://github.com/microsoft/playwright/issues/30842 and https://playwright.dev/docs/network#http-proxy
  if (bannerNotRightStoreEl && !window.navigator.webdriver) {
    const BannerNotRightStoreWrapper = pipe(
      BannerNotRightStoreContainer,
      withSuspense,
      withErrorBoundary,
      withI18next,
      withTheme,
    )

    ReactDOM.createRoot(bannerNotRightStoreEl).render(
      <BannerNotRightStoreWrapper store={$settings.store_nation} />,
    )
  }
}
